import { useCallback } from 'react';
import { useCustomMutation } from './core/useCustomMutation';
import { trackFreeSmartGeneration } from '../../services/api/ai-tools/trackFreeSmartGeneration';

export const useTrackFreeSmartGeneration = () => {
  const { error, isLoading, isSuccess, mutateAsync } = useCustomMutation(() =>
    trackFreeSmartGeneration()
  );

  const trackFreeSmartGen = useCallback(
    () => mutateAsync(undefined),
    [mutateAsync]
  );

  return {
    error,
    isLoading,
    isSuccess,
    trackFreeSmartGen,
  };
};
